/**
 * _Boilerplate.js
 */

import $ from 'jquery';
window.Tether = require('tether');
require('bootstrap');

class Accordions {

	constructor() {

		$('.card').on('show.bs.collapse	', function(e) {

			$('.cross-icon-container.rotate').removeClass('rotate');

			var $crossIcon = $(this).find('.uo-icon-plus');

			$crossIcon.addClass('rotate');

		})

		$('.card').on('hide.bs.collapse	', function(e) {

			var $crossIcon = $(this).find('.uo-icon-plus');

			if ($crossIcon.hasClass('rotate')) {

				$crossIcon.removeClass('rotate')
			}

		})

	}

}
new Accordions();
